import { Component, OnInit, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';
import { EventService } from '../../services/event/event.service';

@Component({
  selector: 'app-video-link-upload-modal',
  templateUrl: './video-link-upload-modal.component.html',
  styleUrls: ['./video-link-upload-modal.component.css']
})
export class VideoLinkUploadModalComponent implements OnInit, AfterViewChecked {

  @ViewChild('closeLinkUploadModal') public closeLinkUploadModal: ElementRef;

  public uniqueId = null;
  public data = {
    name: '',
    link: ''
  };

  constructor(
    private event: EventService
  ) { }

  ngOnInit() {
    this.event.on('video-link-upload-modal', 'showVideoLinkUploadModal', uniqueId => {
      this.uniqueId = uniqueId;
    })
  }

  ngAfterViewChecked() {
    $('#linkUploadModal').on('hidden.bs.modal', () => {
      this.data = {
        name: '',
        link: ''
      };
    })
  }

  onLinkUpload() {
    if (!this.data.name || !this.data.link) {
      swal('Warning', 'Please fill all the fields', 'warning');
      return;
    }

    let validUrl = null;
    try {
      const url = new URL(this.data.link);
      console.log(url);
      validUrl = url.href;
    } catch (err) { validUrl = null; }
    if (!validUrl) {
      swal('Warning', 'Please enter a valid URL', 'warning');
      return;
    }
    this.event.emit('videoLinkUpload', {
      name: this.data.name,
      path: validUrl,
      enc_name: null,
      extension: null,
      uniqueId: this.uniqueId
    });
    this.closeLinkUploadModal.nativeElement.click();
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/video-link-upload-modal/video-link-upload-modal.component.ts